import { Environment } from '../const/Environment'
import { getEnvironment } from './misc'

export const isProduction = () => {
  return getEnvironment() === Environment.production
}
